<script>
    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    // Import primevue components
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';

    export default {
        mixins: [mixin],
        components: {
            DataTable,
            Column,
        },
        props: {
            dossiers: {
                type: Array,
                default: [],
            },
            columns: {
                type: Array,
                default: [],
            },
            sortfield: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                sortObj: {
                    order: -1,
                    field: this.sortfield,
                },
            };
        },
        computed: {
            scrollHeight() {
                if (this.dossiers.length < 12) return (this.dossiers.length * 50 + 50) + 'px';
                return '600px';
            }
        },
    };
</script>

<template>
    <DataTable scrollable 
            :scrollHeight="scrollHeight" 
            :virtualScrollerOptions="{ itemSize: 30 }" 
            :value="dossiers"
            :pt="{ table: 'table table--small table--datatable is-bordered is-fullwidth' }"
            :sortField="sortObj.field"
            :sortOrder="sortObj.order">
        <Column v-for="column of columns"
                :key="column.field"
                :field="column.field"
                :header="column.label"
                sortable>
            <template #sorticon="slotProps">
                <span :class="['icon', { 'soft-hide': !slotProps.sorted }]"><i :class="['fa-solid', 'fa-sm' , slotProps.sorted && slotProps.sortOrder === 1 ? 'fa-caret-up' : 'fa-caret-down']"></i></span>
            </template>
            <template v-if="column.type === 'boolean'" #body="slotProps">
                <i v-if="slotProps.data[column.field] === 'afgesloten'" class="fa-regular fa-lg fa-square-check has-text-grey-light"></i>
                <i v-else class="fa-regular fa-lg fa-square has-text-grey-light"></i>
            </template>
            <template v-if="column.type === 'date'" #body="slotProps">
                {{ toDateStr(slotProps.data[column.field]) }}
            </template>
            <template v-if="column.type === 'link'" #body="slotProps">
                <a :href="column.url + slotProps.data[column.field] + '000'">{{ slotProps.data[column.field] }}</a>
            </template>
            <template v-if="column.type === 'combination'" #body="slotProps">
                {{ slotProps.data[column.field] }} - {{ slotProps.data[column.secondField] }}
            </template>
            <template #body="slotProps">
                {{ slotProps.data[column.field] }}
            </template>
        </Column>
    </DataTable>
</template>
